import { useIsNSMember } from "@/hooks/useIsNSMember";
import { Navigate } from "react-router-dom";
import { ReactNode } from "react";
import { BrandedLoader } from "@/components/BrandedLoader";

interface Props { children: ReactNode; }

export const RequireNSMember = ({ children }: Props) => {
  const { loading, isNSMember } = useIsNSMember();

  if (loading) return <BrandedLoader variant="fullscreen" />;
  if (!isNSMember) return <Navigate to="/app/home" replace />;

  return <>{children}</>;
};
